import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jmultinherit(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
   <Sides/>
   <Helmet>
 
  <title>Java multilevel inheritance tutorial For Beginners</title>
<meta name="description" content="Java multilevel inheritance tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like java tutorial, Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java multilevel inheritance,multilevel inheritance in java,multilevel inheritance in java definition,multilevel inheritance in java small program,multilevel inheritance in java with simple example
,does java support multilevel inheritance,multilevel inheritance in java with example programs,java program to implement multilevel inheritance,multilevel inheritance program in java with output
" />
<link rel="canonical" href="https://www.codeexampler.com/java-multilevel-inheritance" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Multilevel Inheritance in Java</h1>
    <div className="first">
        <a href="/java-single-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-hierarchical-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


<h2 className="headings">Q-Write a Program of multilevel inheritance in java Example?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> a</span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;void </span>
      <span className="qwerty-8">a</span>
      <span className="qwerty-1">()</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"this is a class"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      <span className="qwerty-3">&#125; </span>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> b</span>
      <span className="qwerty-8"> extends</span>
      <span className="qwerty-4"> a</span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;void </span>
      <span className="qwerty-8">b</span>
      <span className="qwerty-1">()</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"this is b class"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}
      <span className="qwerty-3">&#125; </span>
      {"\n"}


      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> c</span>
      <span className="qwerty-8"> extends</span>
      <span className="qwerty-4"> a</span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;void </span>
      <span className="qwerty-8">c</span>
      <span className="qwerty-1">()</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"this is c class"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"}{"\n"}     
       
        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c</span>
      <span className="qwerty-4"> all</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">c</span>
      <span className="qwerty-1">();</span>
      {"\n"} 
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;all</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">();</span>
      {"\n"}   
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;all</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">b</span>
      <span className="qwerty-1">();</span>
      {"\n"}   
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;all</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">c</span>
      <span className="qwerty-1">();</span>
      {"\n"} 
     




      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"} 
      <span className="qwerty-3">&#125; </span>
        {"\n"}





   
    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp;this is a class</span>
      {"\n"}
      <span className="qwerty-9">&nbsp;this is b class</span>
      {"\n"}
      <span className="qwerty-9">&nbsp;this is c class</span>
      {"\n"}
        </code>{"   "}
        </pre>
  </div>
</div>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/java-single-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-hierarchical-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jmultinherit;